import { Injectable } from '@angular/core';
import { CurrentLocation } from '../../models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapConfigService {
  currentLocation$ = new BehaviorSubject<CurrentLocation>(CurrentLocation.Dubai);

  private _iconUrl: string;
  private _iconRetinaUrl: string;
  private _shadowUrl: string;

  // Setters for the paths
  set iconUrl(value: string) {
    this._iconUrl = value;
  }
  // Getters for the paths
  get iconUrl(): string {
    return this._iconUrl;
  }

  set iconRetinaUrl(value: string) {
    this._iconRetinaUrl = value;
  }
  get iconRetinaUrl(): string {
    return this._iconRetinaUrl;
  }

  set shadowUrl(value: string) {
    this._shadowUrl = value;
  }
  get shadowUrl(): string {
    return this._shadowUrl;
  }
}
